import React from 'react'
import { Firm } from './mapper'
import Wrapper from '../../ui/wrapper'
import { Button } from '../../ui'
import ButtonColor from '../../ui/buttonColor'
import { useApplyStore } from '../../../stores/ui/applyStore'

interface ApplyCardProps {
  firm: Firm
  color: string | null
}

export const ApplyCard = ({ firm, color }: ApplyCardProps) => {
  const openApplicationFormModal = useApplyStore(
    (state) => state.openApplicationFormModal,
  )

  const handleClick = () => {
    openApplicationFormModal({
      offices: firm.offices || [],
      colorCareerSite: color || undefined,
      isCareerSiteApply: Boolean(color),
    })
  }

  return (
    <Wrapper>
      <div className="p-2 space-y-2 md:p-4 text-night">
        <p className="text-lg font-semibold text-left">Candidature spontanée</p>
        <p>Nous t&apos;avons convaincu(e) ? Postule dès maintenant !</p>
        {color ? (
          <ButtonColor
            label="Postuler"
            color={color}
            onClick={handleClick}
            size="medium"
            invert
          />
        ) : (
          <Button
            label="Postuler"
            onClick={handleClick}
            color="primary"
            size="medium"
            invert
          />
        )}
      </div>
    </Wrapper>
  )
}
